import React from 'react';
import { Box } from '@mui/material';
import { AudioRecorderCore } from './AudioRecorderCore';

interface VoiceRecorderProps {
  onRecordingComplete: (blob: Blob | null, transcription?: string) => void;
  isSubmitting?: boolean;
}

export const VoiceRecorder: React.FC<VoiceRecorderProps> = ({ 
  onRecordingComplete,
  isSubmitting = false 
}) => {
  return (
    <Box>
      <AudioRecorderCore
        onRecordingComplete={onRecordingComplete}
        isSubmitting={isSubmitting}
      />
    </Box>
  );
};